module.exports = __webpack_public_path__ + "img/88.b01c9681.jpg";